import { ReactNode } from 'react';
import { isAfter, isBefore } from 'date-fns';

import { Button, DatePicker, Row } from 'components/Blocks';

import { CalendarRangeIcon } from 'components/Icons';
import { formatDate } from 'utils/date';

interface DateSliceProps {
  children?: never;

  startDate: Date;
  endDate: Date;
  dispatch: (params: { startDate?: Date; endDate?: Date }) => void;

  divisor?: ReactNode;
}

export function DateSlice({ endDate, startDate, dispatch, divisor }: DateSliceProps): JSX.Element {
  return (
    <Row gap="2">
      <CalendarRangeIcon size={18} />

      <Row gap="2">
        <DatePicker
          disableFuture
          selected={startDate}
          disabled={(date) => (date ? isAfter(date, new Date(endDate)) : true)}
          onSelect={(date) => date && dispatch({ startDate: date })}
        >
          <Button variant="ghost" className="p-1 text-inherit">
            {formatDate(startDate, 'dd/mm/yyyy')}
          </Button>
        </DatePicker>

        {divisor || <span>-</span>}

        <DatePicker
          disableFuture
          selected={endDate}
          disabled={(date) => (date ? isBefore(date, new Date(startDate)) : true)}
          onSelect={(date) => date && dispatch({ endDate: date })}
        >
          <Button variant="ghost" className="p-1 text-inherit">
            {formatDate(endDate, 'dd/mm/yyyy')}
          </Button>
        </DatePicker>
      </Row>
    </Row>
  );
}

export default DateSlice;
